"use strict";
import { isTopazIdConnectorId, usePrivyAuth } from "components/Web3Provider/privy/PrivyWagmiBridge";
import { useAccount } from "hooks/useAccount";
import { Flex, SegmentedControl, Text } from "ui/src";
function ModeLabel({ text, active }) {
  return <Text variant="buttonLabel4" color={active ? "$neutral1" : "$neutral2"} userSelect="none">
      {text}
    </Text>;
}
function modeDescription(mode, smartWalletReady) {
  if (mode === "eoa") {
    return "Standard wallet \u2014 your signer EOA, you pay gas.";
  }
  return smartWalletReady ? "Smart wallet \u2014 gas-free, sponsored transactions." : "Finalizing your smart wallet\u2026";
}
export function WalletModeToggle() {
  const privy = usePrivyAuth();
  const { connector } = useAccount();
  if (!privy || !isTopazIdConnectorId(connector?.id)) {
    return null;
  }
  const { walletMode, setWalletMode, smartWalletReady } = privy;
  return <Flex gap="$spacing6" py="$spacing8">
      <SegmentedControl
    size="small"
    fullWidth
    selectedOption={walletMode}
    onSelectOption={(option) => setWalletMode(option)}
    options={[
      { value: "smart", display: <ModeLabel text="Smart" active={walletMode === "smart"} /> },
      { value: "eoa", display: <ModeLabel text="Standard" active={walletMode === "eoa"} /> }
    ]}
  />
      <Text variant="body4" color="$neutral2">
        {modeDescription(walletMode, smartWalletReady)}
      </Text>
    </Flex>;
}
